import { useState } from 'react'
import { bookingPageTabIds, bookingPageTabs } from '../GSConstants'
import { Box, Tab, Tabs } from '@mui/material'
import { Item } from '../../../common/snippets'
import WeightCharges from './weightCharges'
import MethodOfPackingTable from './MethodOfPackingTab/MethodOfPackingTable'
import LuggageCities from './LuggageCities'
import DocumentsChargeTab from './DocumentsChargeTab'
import FocApprovalTable from './FocApprovalTab/FocApprovalTable'
import { useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import ConsignmentType from './ConsignmentType'
import PickupAndDropoffCharge from './PickupAndDropoffCharge'
import ValuationChargeTable from './ValuationChargeTab/ValuationChargeTable'
import BookingHamali from './BookingHamali'
import PaymentMode from './PaymentMode'
import { PickupAndDropoffCartage } from '../PickupAndDropoffCartage'

const GSBookingPage = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [selectedTab, setSelectedTab] = useState(Number(searchParams.get('id')) || '')
  const [allTabs, setAllTabs] = useState(() => new Set())

  useEffect(() => {
    const stored = sessionStorage.getItem('token1')
    const allGSPagesActive = stored ? JSON.parse(stored) : []
    const activeJobIDSet = new Set()
    for (const item of allGSPagesActive) {
      if (item.IsActive === 1) {
        activeJobIDSet.add(item.JobID)
      }
    }
    if (!selectedTab) {
      const firstActiveTab = bookingPageTabs.find((tab) => activeJobIDSet.has(tab.JobID))
      if (firstActiveTab) {
        goToTabs(firstActiveTab.JobID)
      }
    }

    setAllTabs(activeJobIDSet)
  }, [searchParams, selectedTab])

  const params = Object.fromEntries(searchParams.entries())
  const goToTabs = (lrTab) => {
    params.id = lrTab
    setSearchParams(params)
    setSelectedTab(lrTab)
  }
  const getBookingPageContent = (typeId, label) => {
    switch (typeId) {
      case 209:
        return <MethodOfPackingTable />
      case 50:
        return <ConsignmentType />
      case 443:
        return <WeightCharges />
      case 211:
        return <ValuationChargeTable />
      case 142:
        return <LuggageCities />
      case 206:
        return <h1>Marquee</h1>
      case 511:
        return <PaymentMode />
      case 218:
        return <DocumentsChargeTab />
      case 453:
        return <PickupAndDropoffCharge />
      case 545:
        return <BookingHamali />
      case 294:
        return <FocApprovalTable />
      case 576:
        return <PickupAndDropoffCartage />
      default:
        return label
    }
  }
  const visibleTabs = bookingPageTabs.filter((tab) => allTabs.has(tab.JobID))
  const activeTab = visibleTabs.find((tab) => tab.JobID === selectedTab)
  return (
    <>
      <Box className="bookingPageTabContainer">
        <Item sx={{ paddingTop: 0 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              variant="scrollable"
              value={selectedTab}
              onChange={(e, newValue) => goToTabs(newValue)}
              aria-label="bsic tabs example"
              sx={{
                minHeight: 'unset',
                alignItems: 'center',
                '& .MuiTabs-scrollButtons.Mui-disabled': {
                  opacity: 1,
                  width: '25px',
                  height: '25px',
                  borderRadius: '50px',
                  background: 'grey !important',
                  fontSize: '20px',
                  color: 'white !important',
                  marginTop: '0px',
                },
                '& .Mui-disabled': {
                  backgroundColor: 'transparent !important',
                  border: 'none !important',
                  color: 'red',
                },
                '& .MuiTabs-scrollButtons': {
                  opacity: 1,
                  width: '25px',
                  height: '25px',
                  borderRadius: '50px',
                  background: '#0086ff !important',
                  fontSize: '20px',
                  color: 'white !important',
                  marginTop: '0px',
                },
              }}
            >
              {visibleTabs.map((reqType) => (
                <Tab key={`sender_${reqType.JobID}`} value={reqType.JobID} label={reqType.name} {...bookingPageTabIds(reqType.JobID)} />
              ))}
            </Tabs>
          </Box>
          {activeTab && <Box sx={{ p: 3 }}>{getBookingPageContent(activeTab.JobID, activeTab.name)}</Box>}
        </Item>
      </Box>
    </>
  )
}

export default GSBookingPage
